import { PropType, defineComponent } from 'vue';
import { uiMgr } from '~mall/common/uiMgr';
import { getStylesBinder } from '~mall/common/utils/styles';
import styles from './index.module.less';

const cx = getStylesBinder(styles);

export default defineComponent({
  name: 'TicketEmpty',
  props: {
    /** 空图片属性 */
    imgAttrs: {
      type: Object as PropType<{
        src: string;
        width?: string | number;
        height?: string | number;
      }>,
      default: () => ({
        src: 'https://m.hellobike.com/resource/helloyun/18121/JZ4m4kK9Mx.png',
        width: '1.91rem',
        height: '1.5rem',
      }),
    },
    /** 空状态描述 */
    desc: {
      type: String,
      default: '这边是空的，啥都没有',
    },
    /** 是否隐藏按钮 */
    hideBtn: {
      type: Boolean,
      default: false,
    },
    /** 按钮文本 */
    btnText: {
      type: String,
      default: '去购买省钱套餐',
    },
    /** 按钮点击操作处理函数 */
    btnHandler: {
      type: Function as PropType<{ (): void }>,
      default: null,
    },
  },
  setup: (props) => {
    const handleClick = () => {
      uiMgr.pushPage({ name: 'Bounty' });
    };
    return () => {
      const {
        imgAttrs: {
          src,
          width,
          height,
        },
        desc,
        hideBtn,
        btnText,
        btnHandler,
      } = props;
      return (
        <div class={cx('empty')}>
          <img
            src={src}
            class={cx('empty__img')}
            style={{ width, height }}
          />
          <div class={cx('empty__text')}>{desc}</div>
          {!hideBtn && (
            <div
              class={cx('empty__buy')}
              onClick={btnHandler || handleClick}
            >{btnText}</div>
          )}
        </div>
      );
    };
  },
});
